import React from "react";
import { Colors, FontSize } from "../../../theme/Theme";
import {
  getRBPayrollStatusLabel,
  getRBPayrollStatusTone,
} from "../utils/rbPayrollOwner.formatters";

interface RBPayrollStatusBadgeProps {
  status: string;
}

export const RBPayrollStatusBadge: React.FC<RBPayrollStatusBadgeProps> = ({ status }) => {
  const tone = getRBPayrollStatusTone(status);

  const palette = {
    success: {
      backgroundColor: "rgba(46, 125, 50, 0.12)",
      color: Colors.themeGreen,
      borderColor: "rgba(46, 125, 50, 0.22)",
    },
    warning: {
      backgroundColor: "rgba(239, 122, 47, 0.12)",
      color: "#c05e15",
      borderColor: "rgba(239, 122, 47, 0.24)",
    },
    danger: {
      backgroundColor: "rgba(211, 47, 47, 0.10)",
      color: Colors.red,
      borderColor: "rgba(211, 47, 47, 0.20)",
    },
    default: {
      backgroundColor: Colors.defaultGrey,
      color: Colors.darkGrey,
      borderColor: Colors.mediumGrey,
    },
  }[tone];

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: 999,
        minHeight: 28,
        padding: `4px 10px`,
        fontSize: FontSize.small,
        fontWeight: "bold",
        backgroundColor: palette.backgroundColor,
        color: palette.color,
        border: `1px solid ${palette.borderColor}`,
        whiteSpace: "nowrap",
      }}
    >
      {getRBPayrollStatusLabel(status)}
    </div>
  );
};
